import { Link } from 'react-router-dom';
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from '../ui/alert-dialog';
import { AlertTriangle, Save, Users } from 'lucide-react';

export const UnsavedChangesDialog = ({ open, onOpenChange, onPreviewAnyway, onSaveAndPreview, saving }) => (
      <AlertDialog open={open} onOpenChange={onOpenChange}>
        <AlertDialogContent className="bg-card border-border" data-testid="unsaved-changes-dialog">
          <AlertDialogHeader>
            <AlertDialogTitle className="flex items-center gap-2">
              <AlertTriangle className="w-5 h-5 text-amber-400" /> Modifications non sauvegardées
            </AlertDialogTitle>
            <AlertDialogDescription className="space-y-2">
              <p>Vous avez modifié ce QCM depuis la dernière sauvegarde.</p>
              <p>L'aperçu et les copies générées reflètent uniquement la <span className="text-foreground font-medium">version sauvegardée</span>.</p>
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter className="flex-col sm:flex-row gap-2">
            <AlertDialogCancel data-testid="unsaved-cancel-btn">Annuler</AlertDialogCancel>
            <AlertDialogAction onClick={onPreviewAnyway} className="bg-secondary text-secondary-foreground hover:bg-secondary/80" data-testid="unsaved-preview-anyway-btn">
              Aperçu sans sauvegarder
            </AlertDialogAction>
            <AlertDialogAction onClick={(e) => { e.preventDefault(); onSaveAndPreview(); }} disabled={saving} className="bg-primary text-primary-foreground hover:bg-blue-600" data-testid="unsaved-save-preview-btn">
              <Save className="w-4 h-4 mr-2" /> {saving ? 'Sauvegarde...' : 'Sauvegarder et prévisualiser'}
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
);

export const LeavePageDialog = ({ open, onCancel, onDiscard, onSaveAndLeave, saving }) => (
      <AlertDialog open={open} onOpenChange={(o) => { if (!o) onCancel(); }}>
        <AlertDialogContent className="bg-card border-border" data-testid="leave-page-dialog">
          <AlertDialogHeader>
            <AlertDialogTitle className="flex items-center gap-2">
              <AlertTriangle className="w-5 h-5 text-amber-400" /> Quitter sans sauvegarder ?
            </AlertDialogTitle>
            <AlertDialogDescription>
              Vos modifications sur ce QCM n'ont pas été sauvegardées et seront perdues si vous quittez la page.
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter className="flex-col sm:flex-row gap-2">
            <AlertDialogCancel data-testid="leave-cancel-btn">Rester sur la page</AlertDialogCancel>
            <AlertDialogAction onClick={onDiscard} className="bg-secondary text-secondary-foreground hover:bg-secondary/80" data-testid="leave-discard-btn">
              Quitter sans sauvegarder
            </AlertDialogAction>
            <AlertDialogAction onClick={(e) => { e.preventDefault(); onSaveAndLeave(); }} disabled={saving} className="bg-primary text-primary-foreground hover:bg-blue-600" data-testid="leave-save-btn">
              <Save className="w-4 h-4 mr-2" /> {saving ? 'Sauvegarde...' : 'Sauvegarder et quitter'}
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
);

export const NoStudentsDialog = ({ open, onOpenChange, classe }) => (
      <AlertDialog open={open} onOpenChange={onOpenChange}>
        <AlertDialogContent className="bg-card border-border" data-testid="no-students-dialog">
          <AlertDialogHeader>
            <AlertDialogTitle className="flex items-center gap-2">
              <AlertTriangle className="w-5 h-5 text-amber-400" /> Aucun élève dans cette classe
            </AlertDialogTitle>
            <AlertDialogDescription className="space-y-3">
              <p>La classe <span className="text-foreground font-medium">"{classe}"</span> ne contient aucun élève.</p>
              <p>Ajoutez des élèves depuis la page <span className="text-foreground font-medium">Élèves</span>.</p>
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter className="flex-col sm:flex-row gap-2">
            <AlertDialogAction onClick={() => onOpenChange(false)} variant="secondary">Fermer</AlertDialogAction>
            <AlertDialogAction asChild className="bg-primary text-primary-foreground hover:bg-blue-600">
              <Link to="/students"><Users className="w-4 h-4 mr-2" /> Aller à la page Élèves</Link>
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
);
